import { Link } from "react-router-dom";
import "./PaymentCallback.css";

export const PaymentCancel = () => {
  return (
    <div className="payment-callback cancel">
      <div className="callback-card">
        <div className="cancel-icon">✕</div>
        <h1>Payment Cancelled</h1>
        <p className="callback-message">
          Your payment was cancelled. No charges were made to your account.
        </p>

        <div className="callback-info">
          <p>If you experienced any issues, please contact support.</p>
        </div>

        <div className="callback-actions">
          <Link to="/account/pricing" className="btn-primary">
            Try Again
          </Link>
          <Link to="/dashboard" className="btn-outline">
            Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};
